import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import NewModal from 'react-responsive-modal';
import '../assets/styles/settings.css';
import '../assets/styles/docs.scss';
import '../assets/styles/dashboard.scss';
import { Profile } from './Profile';
import { BulletinBoard } from './BulletinBoard';
import { EditProfile } from './EditProfile';
import { Permissions } from './Permissions';
import { DocsList } from './DocsList';
import { UserDocsList } from '../Resources/UserDocsList';
import { notificationActions, permissionActions } from '../_actions';
import { userActions } from '../_actions';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import ChangePassword from 'ChangePassword';
import ChangeStatusModal from '_components/ChangeStatusModal';
import EmploymentHistory from 'Resources/EmploymentHistory';
import { userService } from '_services/user.service';
import { toast } from 'react-toastify';
import { handleErrorResponse } from '_helpers/helpers';
import { docsService } from '../_services/docs.service';
import ViewProfile from '_components/Profile/ViewProfile';
import { ProfileComponent } from '../common/profile';
import { authHeader, config } from '../_helpers';
import { Link } from 'react-router-dom';
import { dateTimeConstants } from '_constants';

class SettingsProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mainHtml: '',
      step: this.props.match.params.step,
      statusOpen: false,
      status: '',
      available: '',
      statusStep: '1',
      returnDateField: moment(),
      returnDate: '',
      permission: [],
      h1: '',
      sendingDDForm: false,
      send_dd_form_confirm: false,
      reloadKey: 0,
      loader: false,
      mailSendOpen: false,
      message: '',
      alertPop: false,
      alertHead: '',
      alertMsg: '',
      alertFunction: '',
      request_rehire_doc: false,
      request_rehire_doc_status: false,
      removeOpen: false,
      archiveStep: '3a',
      lastDayWorked: moment(),
      lastDayReason: '',
      lastDayReasonErr: '',
      inventoryUserAlert: false,
    };
    this.changeTab = this.changeTab.bind(this);
    this.statusOpenModal = this.statusOpenModal.bind(this);
    this.statusCloseModal = this.statusCloseModal.bind(this);
    this.setStatusReturn = this.setStatusReturn.bind(this);
    this.setStep = this.setStep.bind(this);
    this.changeStatus = this.changeStatus.bind(this);
    this.cancel = this.cancel.bind(this);
    this.editProfile = this.editProfile.bind(this);
    this.documentRequest = this.documentRequest.bind(this);
    this.downloadAllDocuments = this.downloadAllDocuments.bind(this);
    this.downloadAllDocumentsAsPDF = this.downloadAllDocumentsAsPDF.bind(this);
    this.docRequestModalClose = this.docRequestModalClose.bind(this);
    this.handleRemoveEmployee = this.handleRemoveEmployee.bind(this);
    this.removeCloseModal = this.removeCloseModal.bind(this);
    this.collectLastDayWorked = this.collectLastDayWorked.bind(this);
    this.changeLastDayReason = this.changeLastDayReason.bind(this);
    this.handleLastDayChange = this.handleLastDayChange.bind(this);
    this.remove = this.remove.bind(this);
  }

  changeStepParam = (newStep) => {
    const { history, match } = this.props;
    const { hash } = match.params;

    history.replace(`/profile/${hash}/${newStep}`);
  };

  openDdformConfirmModal() {
    this.setState({ send_dd_form_confirm: true });
  }

  ddFormConfirmCloseModal() {
    this.setState({
      send_dd_form_confirm: false,
    });
  }

  sendDDForm() {
    if (this.props.user.items.data.hash) {
      this.setState({
        ...this.state,
        sendingDDForm: true,
        send_dd_form_confirm: false,
      });
      let data = new FormData();
      data.append('user_hash', this.props.user.items.data.hash);
      userService
        .sendDDForm(data)
        .then((res) => {
          if (res.success) {
            toast.success(res.message);
          } else {
            handleErrorResponse(res);
          }
          this.setState({
            ...this.state,
            sendingDDForm: false,
          });
        })
        .catch((error) => {
          toast.error('Failed to send email to user.');
          this.setState({
            ...this.state,
            sendingDDForm: false,
          });
        });
    } else {
      toast.error('An unexpected error occurred.');
    }
  }

  statusOpenModal() {
    this.setState({ statusOpen: true, statusStep: '1' });
  }

  statusCloseModal() {
    this.setState({ statusOpen: false });
  }

  changeTab(tab) {
    this.changeStepParam(tab);
    this.setState({ step: tab }, function () {
      this.componentWillReceiveProps(this.props);
    });
  }
  setStatusReturn(status) {
    if (status) {
      var step = '2a';
    } else step = '2b';

    this.setState({ statusStep: step }, function () {
      this.componentWillReceiveProps(this.props);
    });
  }
  setStep(step) {
    this.setState({ statusStep: step }, function () {
      this.componentWillReceiveProps(this.props);
    });
  }

  handleDateChange(date) {
    this.setState({
      returnDateField: date,
      returnDate: date.format('MM/DD/YY'),
    });
  }

  changeStatus(status, statVal) {
    if (status) {
      var stat = statVal === 'Available' ? 'Unavailable' : 'Available';
      this.setState({ status: stat, loader: true }, function () {
        this.componentWillReceiveProps(this.props);
      });

      let data = new FormData();
      this.statusCloseModal();
      data.append('hash', this.props.match.params.hash);
      data.append('end_date', this.state.returnDate);
      data.append('status', stat);

      var hash = '?hash=' + this.props.match.params.hash;
      if (this.props.match.params.hash === localStorage.getItem('hash')) {
        this.props.dispatch(userActions.changeSelfStatus(data));
      } else {
        this.props.dispatch(userActions.changeStatus(data, hash));
      }
      this.props.dispatch(notificationActions.getCount());
    }
  }

  editProfile() {
    this.setState({ step: 'EditProfile' }, function () {
      this.componentWillReceiveProps(this.props);
    });
  }
  cancel() {
    this.setState({ step: 'Profile' }, function () {
      this.componentWillReceiveProps(this.props);
    });
  }

  // Profile action methods
  mailSendOpenModal() {
    this.setState({ mailSendOpen: true });
  }

  mailSendCloseModal() {
    this.setState({ mailSendOpen: false });
  }

  sendMail(hash) {
    let data = new FormData();
    this.mailSendCloseModal();
    data.append('type', 'mail');
    data.append('message', this.state.message);
    data.append('user_hash', hash);

    var self = this;
    fetch(config.apiUrl + '/api/employee/sendmails', {
      headers: authHeader(),
      method: 'POST',
      body: data,
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.success) {
          self.setState({
            alertPop: true,
            alertHead: 'Success',
            alertMsg: JSON.parse(JSON.stringify(data.message)),
            alertFunction: '',
          });
        } else {
          self.setState({
            alertPop: true,
            alertHead: 'Error',
            alertMsg: JSON.parse(JSON.stringify(data.message)),
            alertFunction: '',
          });
        }
      });
  }

  editProfile(hash) {
    this.setState({ step: 'EditProfile' }, function () {
      this.componentWillReceiveProps(this.props);
    });
  }

  handleRemoveEmployee(e) {
    let inventoryList = this.props.inventory?.inventory?.data || [];
    if (inventoryList && inventoryList.length) {
      this.setState({ inventoryUserAlert: true });
    } else {
      this.setState({ removeOpen: true });
    }
  }

  removeCloseModal() {
    this.setState({ removeOpen: false, archiveStep: '3a' });
  }

  collectLastDayWorked() {
    this.setState({ archiveStep: '3b' });
  }

  changeLastDayReason = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
      lastDayReasonErr: '',
    });
  };

  handleLastDayChange(date) {
    if (date) {
      this.setState({ lastDayWorked: date });
    }
  }

  remove() {
    if (!this.state.lastDayReason.trim()) {
      this.setState({ lastDayReasonErr: 'error' });
      return;
    }
    let data = new FormData();
    this.removeCloseModal();
    data.append('hash', this.props.match.params.hash);
    data.append(
      'last_day_worked',
      moment(this.state.lastDayWorked).format(dateTimeConstants.ISO_DATE_FORMAT)
    );
    data.append('last_day_reason', this.state.lastDayReason);
    this.props.dispatch(userActions.removeEmployee(data)).then(
      (res) => {
        this.setState({
          alertHead: 'Success',
          alertMsg: 'Employee removed successfully.',
          removeOpen: false,
          alertPop: true,
          archiveStep: '3a',
        });
      },
      (err) => {
        this.setState({
          alertPop: true,
          alertHead: 'Error',
          alertMsg:
            'Failed to remove employee ' +
            (typeof err?.message === 'string' ? err.message : ''),
          alertFunction: '',
          removeOpen: false,
          archiveStep: '3a',
        });
      }
    );
  }

  // Document-related methods
  documentRequest(hash, doc_request) {
    this.setState({ doc_request });
    docsService.requestToFillDocs(hash, doc_request).then(
      (res) => {
        this.setState({
          request_rehire_doc_status: res.success,
          request_rehire_doc: true,
        });
        var hash = '?hash=' + this.props.match.params.hash;
        this.props.dispatch(userActions.getProfile(hash));
      },
      (error) => {
        console.error('Error requesting documents:', error);
      }
    );
  }

  docRequestModalClose() {
    this.setState({ request_rehire_doc: false });
  }

  downloadAllDocuments(event, rehire = false) {
    let hash = this.props.match.params.hash;
    let params = {
      uid: this.props.user.profile.data.hash,
      signature: this.props.chat.settings.signature,
    };
    let url = new URL(`${config.apiUrl}/docs/download/${hash}`);
    rehire &&
      (url = new URL(`${config.apiUrl}/docs/download/${hash}?rehire=true`));

    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
    window.open(url.href);
  }

  downloadAllDocumentsAsPDF(event, rehire = false) {
    let hash = this.props.match.params.hash;
    let params = {
      uid: this.props.user.profile.data.hash,
      signature: this.props.chat.settings.signature,
    };
    let url = new URL(`${config.apiUrl}/docs/download/pdf/${hash}`);
    rehire &&
      (url = new URL(`${config.apiUrl}/docs/download/pdf/${hash}?rehire=true`));

    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
    window.open(url.href);
  }

  componentDidMount() {
    console.log('SettingsProfile - componentDidMount:');
    this.props.dispatch(permissionActions.getPermission());
    if (this.props.match.path === '/profile/:hash/docs/:category/:doc/:id') {
      this.changeTab('docs-list');
    }
  }

  componentDidUpdate(prevProps) {
    const { user } = this.props;
    if (user?.changeStatusSuccess && !prevProps.user?.changeStatusSuccess) {
      this.statusCloseModal();
      this.setState({ reloadKey: this.state.reloadKey + 1, loader: false });
    }

    if (user?.changeStatusFailure && !prevProps.user?.changeStatusFailure) {
      this.statusCloseModal();
      this.setState({ loader: false });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { permission } = this.props;
    if (permission.permissions) {
      this.setState({ permission: permission.permissions.data });
    }

    // Only handle user data for non-profile tabs or when profile data is available
    if (nextProps.user.items && this.state.step !== 'profile') {
      var admin = nextProps.user.items.data.is_admin !== 0 ? true : false;
      if (
        this.props.match.path === '/profile/:hash/:step' ||
        this.props.match.path === '/profile/:hash/docs/:category/:doc/:id'
      ) {
        this.setState({
          h1:
            nextProps.user.items.data.first_name +
            ' ' +
            (nextProps.user.items.data.middle_name
              ? nextProps.user.items.data.middle_name + ' '
              : '') +
            nextProps.user.items.data.last_name,
          admin,
          namePrefix: nextProps.user.items.data.first_name,
        });
      } else {
        this.setState({ h1: 'Profile & Settings', admin, namePrefix: 'you' });
      }
      var available =
        nextProps.user.items.data.active === 'Available' ? true : false;
      this.setState({
        status: nextProps.user.items.data.active,
        available: available,
      });
    }
    var options;
    if (this.state.step === 'profile') {
      options = (
        <div>
          <ProfileComponent
            hash={this.props.match.params.hash}
            user={this.props.user}
            permission={this.props.permission}
            inventory={this.props.inventory}
            chat={this.props.chat}
            dispatch={this.props.dispatch}
            match={this.props.match}
            history={this.props.history}
            isSettingsContext={true}
            onProfileDataLoaded={(profileData) => {
              if (profileData) {
                var admin = profileData.is_admin !== 0 ? true : false;
                this.setState({
                  h1: profileData.first_name + ' ' + profileData.last_name,
                  admin,
                  namePrefix: profileData.first_name,
                  status: profileData.active,
                  available: profileData.active === 'Available' ? true : false,
                });
              }
            }}
          />
        </div>
      );
    }
    if (this.state.step === 'docs-list') {
      options = (
        <div>
          <UserDocsList userHash={this.props.match.params.hash} />
        </div>
      );
    }
    if (this.state.step === 'employment-history') {
      options = (
        <div style={{ backgroundColor: 'white', minHeight: 300 }}>
          <EmploymentHistory hash={this.props.match.params.hash} />
        </div>
      );
    }
    if (this.state.step === 'bulletin') {
      options = (
        <div>
          <BulletinBoard />
        </div>
      );
    }
    if (this.state.step === 'permissions') {
      options = (
        <div>
          <Permissions />
        </div>
      );
    }
    this.setState({ mainHtml: options });
  }
  //
  render() {
    const { permission, user } = this.props;
    var permList = [];
    if (permission.permissions) {
      permList = permission.permissions.data;
    }

    var admin = false,
      editPerm = true,
      userItem;

    if (
      this.props.user.profile &&
      (!this.props.match.path === '/profile/:hash' ||
        this.props.match.path === '/profile/:hash/docs/:category/:doc/:id')
    ) {
      userItem = this.props.user.profile;
    } else if (this.props.user.items) {
      userItem = this.props.user.items;
    }

    let userData = user.profile ? user.profile.data : {};
    var namePrefix = '';
    if (userItem) {
      var status = userItem.data.active;
      var available = userItem.data.active === 'Available' ? true : false;
      admin = userItem.data.is_admin !== 0 ? true : false;
      var h1 = 'Settings';
      namePrefix = 'you';

      if (userData?.id != userItem?.data?.id) {
        h1 =
          userItem.data.first_name +
          ' ' +
          (userItem.data.middle_name ? userItem.data.middle_name + ' ' : '') +
          userItem.data.last_name;
        editPerm = permList.includes('Status Update') ? true : false;
        namePrefix = this.state.namePrefix;
      }
    }

    // if(userItem){
    return (
      <div>
        <div>
          <div className="settings_container">
            <div className="breadcrumbs">
              <Link
                to={'/resources'}
                className="green"
              >
                Resources
              </Link>{' '}
              / <Link to={'/resources/' + (userItem?.data?.crew_identifier_id || '')}>Details</Link> /
              Profile
            </div>
            <div className="page_title float">
              <h1 className="">{this.state.h1}</h1>

              <div className="btn_list">
                    {this.state.step === 'profile' ? (
                      <React.Fragment>
                        {permList.includes('Manage Passwords') && (
                          <ChangePassword
                            userType="user"
                            user={userItem?.data}
                            isAdmin={
                              this.props?.user?.profile?.data?.is_admin !== 0
                                ? true
                                : false
                            }
                          />
                        )}
                        <button
                          className="button "
                          onClick={() => window.print()}
                        >
                          Print
                        </button>
                        {permList.includes('Message Employees') && (
                          <button
                            className="button "
                            onClick={this.mailSendOpenModal.bind(this)}
                          >
                            Message
                          </button>
                        )}
                        {editPerm && (
                          <button
                            className="button "
                            onClick={this.statusOpenModal.bind(this)}
                          >
                            Edit Status
                          </button>
                        )}

                        {permList.includes('Remove Employee') && (
                          <button
                            className="button "
                            onClick={this.handleRemoveEmployee.bind(this)}
                          >
                            Remove Employee
                          </button>
                        )}
                        {permList.includes('Send DD Form') && (
                          <button
                            className="button "
                            onClick={this.openDdformConfirmModal.bind(this)}
                            disabled={this.state.sendingDDForm}
                          >
                            Send DD Form
                          </button>
                        )}
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        {permList.includes('Manage Docs') &&
                          userItem?.data?.docs_status === -1 && (
                            <button
                              className={`button edit_resource ${userItem?.data && userItem?.data.rehire_docs_status !== -1 && 'disabled'}`}
                              onClick={() =>
                                this.documentRequest(userItem?.data?.hash, 'onboarding')
                              }
                              disabled={userItem?.data && userItem?.data.docs_status !== -1}
                            >
                              {userItem?.data && userItem?.data.docs_status === -1
                                ? 'Ask to Fill Onboarding Documents'
                                : 'Asked to Fill Onboarding Documents'}
                            </button>
                          )}
                        {permList.includes('Manage Docs') &&
                          userItem?.data?.rehire_docs_status === -1 &&
                          userItem?.data?.docs_status >= 2 && (
                            <button
                              className={`button edit_resource ${userItem?.data && userItem?.data.rehire_docs_status !== -1 && 'disabled'}`}
                              onClick={() =>
                                this.documentRequest(userItem?.data?.hash, 'rehire')
                              }
                              disabled={userItem?.data && userItem?.data.rehire_docs_status !== -1}
                            >
                              {userItem?.data && userItem?.data.rehire_docs_status === -1
                                ? 'Ask to Fill Rehire Documents'
                                : 'Asked to Fill Rehire Documents'}
                            </button>
                          )}
                        {permList.includes('Manage Docs') &&
                          userItem?.data?.docs_status >= 2 && (
                            <button
                              className="button edit_resource"
                              onClick={this.downloadAllDocuments}
                              title="Download Onboarding documents as ZIP File"
                            >
                              Onboarding{' '}
                              <i className="fas fa-file-archive text-white inline-icons"></i>
                            </button>
                          )}
                        {permList.includes('Manage Docs') &&
                          userItem?.data?.docs_status >= 2 && (
                            <button
                              className="button primary edit_resource"
                              onClick={this.downloadAllDocumentsAsPDF}
                              title="Download Onboarding documents as PDF"
                            >
                              Onboarding{' '}
                              <i className="fas fa-file-pdf text-white inline-icons"></i>
                            </button>
                          )}
                        {permList.includes('Manage Docs') &&
                          userItem?.data?.rehire_docs_status >= 2 && (
                            <button
                              className="button edit_resource"
                              onClick={(event) =>
                                this.downloadAllDocuments(event, true)
                              }
                              title="Download Rehire documents as ZIP File"
                            >
                              Rehire{' '}
                              <i className="fas fa-file-archive text-white inline-icons"></i>
                            </button>
                          )}
                        {permList.includes('Manage Docs') &&
                          userItem?.data?.rehire_docs_status >= 2 && (
                            <button
                              className="button primary edit_resource"
                              onClick={(event) =>
                                this.downloadAllDocumentsAsPDF(event, true)
                              }
                              title="Download Rehire documents as PDF"
                            >
                              Rehire{' '}
                              <i className="fas fa-file-pdf text-white inline-icons"></i>
                            </button>
                          )}
                      </React.Fragment>
                    )}
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="inner_head">
                  <h2
                    className={this.state.step === 'profile' ? 'active' : ''}
                    onClick={this.changeTab.bind(this, 'profile')}
                  >
                    Profile
                  </h2>
                  {
                    <h2
                      className={
                        this.state.step === 'docs-list' ? 'active' : ''
                      }
                      onClick={this.changeTab.bind(this, 'docs-list')}
                    >
                      Documents
                    </h2>
                  }
                  {permList.includes('Manage Employment History') && (
                    <h2
                      className={
                        this.state.step === 'employment-history' ? 'active' : ''
                      }
                      onClick={this.changeTab.bind(this, 'employment-history')}
                    >
                      Application History
                    </h2>
                  )}
                  {this.props.match.params.hash ==
                    this.props.user?.profile?.data.hash && (
                    <>
                      {admin &&
                        this.props.match.path !== '/profile/:hash' &&
                        this.props.match.path !==
                          '/profile/:hash/docs/:category/:doc/:id' && (
                          <h2
                            className={
                              this.state.step === 'permissions' ? 'active' : ''
                            }
                            onClick={this.changeTab.bind(this, 'permissions')}
                          >
                            Permissions
                          </h2>
                        )}
                    </>
                  )}
                  {this.state.permission.includes('Bulletin Board') &&
                    this.props.match.path !== '/profile/:hash/:step' &&
                    this.props.match.path !==
                      '/profile/:hash/docs/:category/:doc/:id' && (
                      <h2
                        className={
                          this.state.step === 'Bulletin' ? 'active' : ''
                        }
                        onClick={this.changeTab.bind(this, 'bulletin')}
                      >
                        Bulletin Board
                      </h2>
                    )}
                </div>
                <div className="tab-contents">{this.state.mainHtml}</div>
              </div>
            </div>
            {this.state.statusOpen ? (
              <ChangeStatusModal
                open={this.state.statusOpen}
                onClose={this.statusCloseModal}
              />
            ) : null}
            <Modal
              id="remove_popup"
              className="status_popup"
              open={this.state.send_dd_form_confirm}
              onClose={this.ddFormConfirmCloseModal.bind(this)}
              little
            >
              <div id="removePopup">
                <div className="modal-head">
                  <h4 className="modal-title">Direct Deposit Form</h4>
                </div>
                <div className="modal-body">
                  <label>
                    This will send an email to{' '}
                    {this.state.h1 ? this.state.h1 : 'this employee'}, with
                    Direct Deposit form link.
                  </label>
                  <br />
                  <button
                    className="button grey"
                    onClick={this.ddFormConfirmCloseModal.bind(this)}
                  >
                    Cancel
                  </button>
                  <button
                    className="button"
                    onClick={this.sendDDForm.bind(this)}
                  >
                    Send
                  </button>
                </div>
              </div>
            </Modal>
            <Modal
              id="email_popup"
              className="status_popup"
              open={this.state.mailSendOpen}
              onClose={this.mailSendCloseModal.bind(this)}
              little
            >
              <div id="emailPopup">
                <div className="modal-head">
                  <h4 className="modal-title">Custom Message</h4>
                </div>
                <div className="modal-body">
                  <textarea
                    name="message"
                    cols="80"
                    rows="10"
                    value={this.state.message}
                    onChange={(e) => this.setState({ message: e.target.value })}
                  />
                  <p className="step_no">
                    Signature will automatically be included.
                  </p>
                  <button
                    className="button grey"
                    onClick={this.mailSendCloseModal.bind(this)}
                  >
                    Cancel
                  </button>
                  <button
                    className="button"
                    onClick={this.sendMail.bind(this, this.props.match.params.hash)}
                  >
                    Send
                  </button>
                </div>
              </div>
            </Modal>
            {this.state.alertPop && (
              <div className="alert-popup">
                <div className="alert-content">
                  <h4>{this.state.alertHead}</h4>
                  <p>{this.state.alertMsg}</p>
                  <button
                    className="button"
                    onClick={() => this.setState({ alertPop: false })}
                  >
                    Ok
                  </button>
                </div>
              </div>
            )}
            {this.state.request_rehire_doc && (
              <Modal
                id="doc_request_popup"
                className="status_popup"
                open={this.state.request_rehire_doc}
                onClose={this.docRequestModalClose}
                little
              >
                <div id="docRequestPopup">
                  <div className="modal-head">
                    <h4 className="modal-title">Document Request</h4>
                  </div>
                  <div className="modal-body">
                    <p>
                      {this.state.request_rehire_doc_status
                        ? 'Document request sent successfully!'
                        : 'Failed to send document request. Please try again.'}
                    </p>
                    <button
                      className="button"
                      onClick={this.docRequestModalClose}
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </Modal>
            )}
            <NewModal
              id="remove_popup"
              className="status_popup"
              open={this.state.removeOpen}
              onClose={this.removeCloseModal}
              little
            >
              <div id="removePopup">
                <div className="modal-head">
                  <h4 className="modal-title">
                    Remove Employee:{' '}
                    {userItem?.data
                      ? userItem.data.first_name + ' ' + userItem.data.last_name
                      : ''}
                  </h4>
                </div>
                <div className="modal-body">
                  {this.state.archiveStep == '3a' && (
                    <div>
                      <label>
                        Are you sure you want to archive this employee?
                      </label>
                      <br />
                      <button
                        className="button grey"
                        onClick={this.removeCloseModal}
                      >
                        Cancel
                      </button>
                      <button
                        className="button"
                        onClick={this.collectLastDayWorked}
                      >
                        Archive
                      </button>
                    </div>
                  )}
                  {this.state.archiveStep == '3b' && (
                    <div className="status_step step1">
                      <section
                        className="d-flex flex-column checkb"
                        style={{ padding: '10px' }}
                      >
                        <div className="full-width">
                          <p>Last Day Worked</p>
                          <DatePicker
                            className="lastDayWorked"
                            name="lastDayWorked"
                            selected={this.state.lastDayWorked}
                            onChange={this.handleLastDayChange}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                          />
                          <textarea
                            rows="3"
                            maxLength={1200}
                            className="lastDayReason"
                            value={this.state.lastDayReason}
                            name="lastDayReason"
                            onChange={this.changeLastDayReason}
                            placeholder="Reason for removal..."
                          />
                          {this.state.lastDayReasonErr && (
                            <div className="error-message">
                              Please provide a reason for removal.
                            </div>
                          )}
                        </div>
                      </section>
                      <div className="user-status-edit-wrapper">
                        <div>
                          <button
                            disabled={this.state.loader}
                            className="button grey"
                            onClick={this.removeCloseModal}
                          >
                            Cancel
                          </button>
                        </div>
                        <div>
                          <button
                            disabled={this.state.loader}
                            className="button"
                            onClick={this.remove}
                          >
                            Ok
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </NewModal>
            {this.state.inventoryUserAlert && (
              <Modal
                id="inventory_alert_popup"
                className="status_popup"
                open={this.state.inventoryUserAlert}
                onClose={() => this.setState({ inventoryUserAlert: false })}
                little
              >
                <div id="inventoryAlertPopup">
                  <div className="modal-head">
                    <h4 className="modal-title">Inventory Alert</h4>
                  </div>
                  <div className="modal-body">
                    <p>
                      This employee has inventory items assigned. Are you sure you want to proceed with removal?
                    </p>
                    <button
                      className="button grey"
                      onClick={() => this.setState({ inventoryUserAlert: false })}
                    >
                      Cancel
                    </button>
                    <button
                      className="button"
                      onClick={() => {
                        this.setState({ inventoryUserAlert: false, removeOpen: true });
                      }}
                    >
                      Proceed
                    </button>
                  </div>
                </div>
              </Modal>
            )}
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  const { applicants, user, permission, inventory, chat } = state;
  return {
    applicants,
    user,
    permission,
    inventory,
    chat,
  };
}
const connectedHomePage = connect(mapStateToProps)(SettingsProfile);
export { connectedHomePage as SettingsProfile };
